import PropTypes from 'prop-types';

import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';

function Edit({ children }) {
  return (
    <Stack as={Text} color="primary" size="sm" spacing={2}>
      {children}
    </Stack>
  );
}

Edit.propTypes = {
  children: PropTypes.node.isRequired
};

export default Edit;
